import { SECURITY_MESSAGES } from '../utils/constants';
import { drawSecureViewerWatermark } from '../utils/secureViewerWatermark';

/**
 * Service for implementing security measures
 */
class SecurityService {
  constructor() {
    this.devToolsOpen = false;
    this.devToolsCheckInterval = null;
    this.listeners = [];
  }

  /**
   * Initialize all security measures
   */
  initialize(onSecurityViolation) {
    this.preventRightClick();
    this.preventKeyboardShortcuts();
    this.detectDevTools(onSecurityViolation);
    this.preventTextSelection();
    this.preventDragAndDrop();
    
    console.log('🔒 Security measures initialized');
  }

  /**
   * Clean up security measures
   */
  cleanup() {
    this.removeAllListeners();
    if (this.devToolsCheckInterval) {
      clearInterval(this.devToolsCheckInterval);
    }
    console.log('🔓 Security measures removed');
  }

  /**
   * Prevent right-click context menu
   */
  preventRightClick() {
    const handler = (e) => {
      e.preventDefault();
      console.warn('Right-click blocked');
      return false;
    };
    
    document.addEventListener('contextmenu', handler);
    this.listeners.push({ event: 'contextmenu', handler });
  }

  /**
   * Prevent keyboard shortcuts for saving, printing, etc.
   */
  preventKeyboardShortcuts() {
    const handler = (e) => {
      // Prevent Ctrl+S (Save)
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
        console.warn('Save shortcut blocked');
        alert(SECURITY_MESSAGES.DOWNLOAD_BLOCKED);
        return false;
      }
      
      // Prevent Ctrl+P (Print)
      if (e.ctrlKey && e.key === 'p') {
        e.preventDefault();
        console.warn('Print shortcut blocked');
        alert(SECURITY_MESSAGES.DOWNLOAD_BLOCKED);
        return false;
      }
      
      // Prevent Ctrl+Shift+I (DevTools)
      if (e.ctrlKey && e.shiftKey && e.key === 'I') {
        e.preventDefault();
        console.warn('DevTools shortcut blocked');
        return false;
      }
      
      // Prevent F12 (DevTools)
      if (e.key === 'F12') {
        e.preventDefault();
        console.warn('DevTools shortcut blocked');
        return false;
      }
      
      // Prevent Ctrl+U (View Source)
      if (e.ctrlKey && e.key === 'u') {
        e.preventDefault();
        console.warn('View source blocked');
        return false;
      }
    };
    
    document.addEventListener('keydown', handler);
    this.listeners.push({ event: 'keydown', handler });
  }

  /**
   * Detect if DevTools is open
   */
  detectDevTools(onDetected) {
    const threshold = 160;
    
    const checkDevTools = () => {
      const widthDiff = window.outerWidth - window.innerWidth;
      const heightDiff = window.outerHeight - window.innerHeight;
      
      if (widthDiff > threshold || heightDiff > threshold) {
        if (!this.devToolsOpen) {
          this.devToolsOpen = true;
          console.error('⚠️ DevTools detected!');
          if (onDetected) {
            onDetected();
          }
        }
      } else {
        this.devToolsOpen = false;
      }
    };
    
    // Check every second
    this.devToolsCheckInterval = setInterval(checkDevTools, 1000);
    
    // Initial check
    checkDevTools();
  }

  /**
   * Prevent text selection
   */
  preventTextSelection() {
    const handler = (e) => {
      e.preventDefault();
      return false;
    };
    
    document.addEventListener('selectstart', handler);
    this.listeners.push({ event: 'selectstart', handler });
  }

  /**
   * Prevent drag and drop
   */
  preventDragAndDrop() {
    const handler = (e) => {
      e.preventDefault();
      return false;
    };
    
    document.addEventListener('dragstart', handler);
    this.listeners.push({ event: 'dragstart', handler });
  }

  /**
   * Remove all event listeners
   */
  removeAllListeners() {
    this.listeners.forEach(({ event, handler }) => {
      document.removeEventListener(event, handler);
    });
    this.listeners = [];
  }

  /**
   * Add watermark overlay to canvas.
   * Kept for the legacy DocumentCanvas path; the primary secure viewer uses
   * the same shared renderer so watermark visibility stays consistent.
   */
  addCanvasWatermark(ctx, text, canvasWidth, canvasHeight) {
    drawSecureViewerWatermark(ctx, text, canvasWidth, canvasHeight);
  }
}

export default new SecurityService();